export default class {
  constructor (config) {
    this.product = config.product
    this.layout = config.layout

    // Art categories for silicone products
    try {
      this.artCategories = config.artCategories
    } finally {}

    // Art for silicone products
    try {
      this.art = config.art
    } finally {}

    // Art for Tyvek products
    try {
      this.artwork = []
    } finally {}

    // Art categories for Tyvek products
    try {
      this.artworkCategories = []
    } finally {}

    try {
      this.patternCategories = []
    } finally {}

    try {
      this.backgroundCategories = []
    } finally {}

    try {
      this.isAdmin = false
    } finally {}
  }

  checkVisibleStates (printStyle) {
    let state, i
    if (printStyle.print_style.code === 'blank') {
      for (let state of this.layout.manifest.states) {
        if (state.state === 'bandbuilder.silicone.text' || state.state === 'bandbuilder.silicone.graphics') {
          state.hidden = true
        } else {
          state.hidden = false
        }
      }
    } else {
      for (i = 0; i < this.layout.manifest.states.length; i++) {
        state = this.layout.manifest.states[i]
        state.hidden = false
      }
    }
  }
}
